import {useMutation} from 'react-query';
import {countriesService} from '../../../../shared/services/configuration/countries';
import {ICreateRegion} from '../../../../shared/services/configuration/countries/dtos/create-region';

export const useCreateRegion = () => {
  return useMutation((payload: ICreateRegion) => {
    return countriesService.createRegion(payload);
  });
};
